import view from './view.html';

/* @ngInject */
export default function (PreferencesService, toastr) {
	return {
		restrict: 'E',
		template: view,
		replace:  true,
		link:     (scope) => {
			scope.dateFormats    = PreferencesService.getDateFormatList();
			scope.timeFormats    = PreferencesService.getTimeFormatList();
			scope.dateTimeOrders = PreferencesService.getDateTimeFormatList();

			scope.dateTimeFormat = PreferencesService.getDateTimePreference();

			scope.savePreferences = () => {
				PreferencesService.setDateTimePreference(scope.dateTimeFormat.date, scope.dateTimeFormat.time, scope.dateTimeFormat.order);
				
				toastr.clear();
				toastr.success('Preferences saved, please refresh page to display changes', 'Saved');

				scope.dropdownOpen = false;
			};
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/preferences/index.js